import * as types from './mutation-types'

export default {
  setUser ({ commit }, payload) {
    commit(types.SET_USER, payload)
  }
}
